import { NotificationConfig } from '../../_core/types/theme/Notification.type';

const notification: NotificationConfig = {
  seo: {
    title: 'Notifications - MysticWork',
    description: '',
  },
};

export default notification;
